import React, { useEffect, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import Container from '../../../../components/Container'
import { useLoading } from '../../../../hooks/loading'
import api from '../../../../services/api'
import { FormAgency } from '../components/Form'
import { apiGetByIdUpdatePage } from '../domain/api'
import { nameActions } from '../domain/info'
import { breadcrumbUpdate } from '../domain/breadcrumb'
import { toolsUpdate } from '../domain/tools'
import { useToast } from '../../../../hooks/toast'

const AgencyUpdate = (): JSX.Element => {
  const { addToast } = useToast()
  const location = useLocation()
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const { activeLoading, disableLoading } = useLoading()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [agencyItem, setAgencyItem] = useState<{
    id: string
    promoter_id: number
    name: string
    cnpj: string
    street: string
    number?: string
    complement?: string
    district: string
    city: string
    uf: string
    zip_code: string
    country: string
    phone_number?: string | null
    latitude?: string | null
    longitude?: string | null
    location_link_maps?: string | null
    partnership_type: string
  }>()

  useEffect(() => {
    async function loadData() {
      activeLoading()
      try {
        const response = await api.get(apiGetByIdUpdatePage(id))
        const { data } = response
        setAgencyItem(data)
        disableLoading()
      } catch (err) {
        const [, baseUrl, path] = location.pathname.split('/')
        disableLoading()
        addToast({
          type: 'error',
          title: 'Error ao carregar o agência',
          description:
            'Houve um error ao carregar o agência, tente novamente mais tarde!'
        })
        if (path.includes('update')) {
          history.push(`/${baseUrl}`)
        } else {
          history.push(`/${baseUrl}/${path}`)
        }
      }
    }
    loadData()
  }, [activeLoading, addToast, disableLoading, history, id, location.pathname])

  return (
    <Container
      pageTitle={nameActions.update.name}
      breadcrumb={breadcrumbUpdate}
      tools={toolsUpdate}
    >
      <FormAgency
        typeForm="update"
        initialValues={
          agencyItem
            ? {
                idUpdate: Number(agencyItem?.id),
                ...agencyItem
              }
            : undefined
        }
      />
    </Container>
  )
}

export default AgencyUpdate
